var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0789 16.2H12.9737V13.95H15.2105V13.05H12.9737V10.8H12.0789V13.05H9.8421V13.95H12.0789V16.2ZM12.5263 18C11.2886 18 10.2337 17.5614 9.36163 16.6842C8.48897 15.8064 8.05263 14.745 8.05263 13.5C8.05263 12.255 8.48897 11.1936 9.36163 10.3158C10.2337 9.4386 11.2886 9 12.5263 9C13.764 9 14.8192 9.4386 15.6919 10.3158C16.564 11.1936 17 12.255 17 13.5C17 14.745 16.564 15.8064 15.6919 16.6842C14.8192 17.5614 13.764 18 12.5263 18ZM0 16.2V5.4L7.15789 0L14.3158 5.4V7.47C14.0175 7.38 13.7193 7.3125 13.4211 7.2675C13.1228 7.2225 12.8246 7.2 12.5263 7.2C10.7816 7.2 9.30168 7.8111 8.08663 9.0333C6.87098 10.2561 6.26316 11.745 6.26316 13.5C6.26316 13.98 6.31177 14.445 6.409 14.895C6.50563 15.345 6.65833 15.78 6.86711 16.2H0Z",
    fill: "#D83F87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookTest);
export default __webpack_public_path__ + "static/media/bookTest.e8a653f3bb5ba48a0a535559674f20c8.svg";
export { ForwardRef as ReactComponent };